import { create } from 'zustand';

export type StatusFilterKey = 'at_risk' | 'on_track' | 'planning' | 'complete';

interface ProjectState {
  selectedProjectId: string | null;
  statusFilters: StatusFilterKey[];
  searchQuery: string;
  setSelectedProject: (id: string | null) => void;
  toggleStatusFilter: (filter: StatusFilterKey) => void;
  clearStatusFilters: () => void;
  setSearchQuery: (query: string) => void;
}

export const useProjectStore = create<ProjectState>((set) => ({
  selectedProjectId: null,
  statusFilters: [],
  searchQuery: '',
  setSelectedProject: (id) => set({ selectedProjectId: id }),
  toggleStatusFilter: (filter) =>
    set((state) => ({
      statusFilters: state.statusFilters.includes(filter)
        ? state.statusFilters.filter((f) => f !== filter)
        : [...state.statusFilters, filter],
    })),
  clearStatusFilters: () => set({ statusFilters: [] }),
  setSearchQuery: (query) => set({ searchQuery: query }),
}));
